import React from 'react'
import { Link } from 'react-router-dom'
import { C, fOutfit, fBody, fMono, PublicNav, PublicFooter } from '../../../Shared/Brand'
import { Icon } from '../../../Shared/Icons'

const SIGNALS = [
  { icon: 'barChart', title: '24h Volume', desc: 'Total traded value over the last 24 hours — higher volume generally means tighter spreads and easier execution.' },
  { icon: 'trendUp', title: 'Price Change', desc: 'Percentage move over a given window, shown live on the homepage ticker across BTC, ETH, DeFi, and stablecoin pairs.' },
  { icon: 'droplet', title: 'Liquidity Depth', desc: 'How much size the order book can absorb before price moves — the Arbitrade Bot factors this into every execution.' },
  { icon: 'network', title: 'Cross-Exchange Spread', desc: 'The live price difference for the same asset across connected exchanges — the raw signal arbitrage strategies are built on.' },
]

export default function MarketInsights() {
  return (
    <div style={{ background: C.white, color: C.tx, fontFamily: fBody, minHeight: '100vh' }}>
      <style>{`
        .xmk-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 20px; }
      `}</style>
      <PublicNav active="Resources" />

      <section style={{ padding: '130px 24px 60px', textAlign: 'center', background: C.dark, color: C.ltx, borderBottom: `1px solid ${C.dbdr}` }}>
        <div style={{ fontSize: '11px', fontFamily: fMono, letterSpacing: '0.14em', color: C.primary, textTransform: 'uppercase', marginBottom: '10px' }}>Markets</div>
        <h1 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(32px,5vw,48px)', lineHeight: 1.1, margin: '0 0 14px' }}>Market Insights</h1>
        <p style={{ fontSize: '16px', fontWeight: 500, color: C.ltx2, maxWidth: '560px', margin: '0 auto' }}>How to read the signals that drive arbitrage opportunities, and where to find them live on Xperia Capital.</p>
      </section>

      <section style={{ padding: '64px 24px', maxWidth: '1100px', margin: '0 auto' }}>
        <h2 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(26px,3.5vw,34px)', lineHeight: 1.1, textAlign: 'center', margin: '0 0 40px', color: C.tx }}>Signals That Matter</h2>
        <div className="xmk-grid">
          {SIGNALS.map(s => (
            <div key={s.title} style={{ textAlign: 'center' }}>
              <div style={{ color: C.primary, display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
                <Icon name={s.icon} size={36} strokeWidth={1.5} />
              </div>
              <div style={{ fontFamily: fOutfit, fontWeight: 600, fontSize: '18px', color: C.tx, marginBottom: '8px' }}>{s.title}</div>
              <p style={{ fontSize: '14px', color: C.tx2, lineHeight: 1.6, margin: 0 }}>{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section style={{ padding: '64px 24px', borderTop: `1px solid ${C.bdr}`, background: C.light, textAlign: 'center' }}>
        <h2 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(24px,3vw,30px)', lineHeight: 1.1, margin: '0 0 14px', color: C.tx }}>Live Prices, Updated Every Few Seconds</h2>
        <p style={{ fontSize: '16px', fontWeight: 500, color: C.tx2, maxWidth: '560px', margin: '0 auto 24px' }}>
          The market ticker on our homepage streams live pricing across BTC, ETH, DeFi, and stablecoin pairs via Binance, filterable by category.
        </p>
        <Link to="/" style={{ display: 'inline-block', background: C.primary, color: C.dark, fontWeight: 700, fontSize: '13px', padding: '12px 24px', borderRadius: '999px', textDecoration: 'none' }}>View Live Ticker</Link>
      </section>

      <PublicFooter />
    </div>
  )
}
